import { Checkbox, TableBody, TableCell } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import CustomHeading from '../../components/CustomHeading'
import CustomPagination from '../../components/CustomPagination'
import ConfirmDialog from '../../components/Dialog/ConfirmDialog'
import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useCustomerType } from '../../hooks/CompanyConfiguration/useCustomerType'

import { formatDate, handleSelectAllClick, handleSelectedItem, isSelected, paginatedData, paginatePages, ROUTES } from '../../shared/constants'
import { itemsPerPage } from '../../shared/data'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { useHistory } from 'react-router'
import { NoDataFound } from '../../components/NoDataFound'
import Loader from '../../components/Loader'

function CustomerTypes() {
  const { customerTypes } = useContext(ConfigurationContext)
  const { getAllCustomerType, deleteCustomerType, deleteManyCustomerType, BulkUpload, loading, paginate } = useCustomerType()

  const [searchQuery, setSearchQuery] = useState('')

  const filterCustomerType = customerTypes ? customerTypes.filter((customerType) => customerType && customerType.name && customerType.name.toLowerCase().includes(searchQuery.toLowerCase())) : []
  const [page, setPage] = React.useState(1)

  const [selected, setSelected] = React.useState([])
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  // const noOfPages = paginate && paginate.totalPage
  const noOfPages = paginatePages(filterCustomerType)
  const handleChange = (event, value) => {
    setPage(value)
  }

  let multipleId = []
  selected.length && selected.map((item) => multipleId.push(item._id))
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)
  const history = useHistory()

  useEffect(() => {
    getAllCustomerType({})
  }, [])

  return (
    <Layout
      heading="Customer Type"
      url={ROUTES.ADD_CUSTOMERTYPE}
      selectedData={selected}
      setDeleteDialog={setDeleteDialog}
      // deleteData={}
      editUrl={`/edit-customerType/${selected.length && selected[0]._id}`}
      setMultipleDeleteDialog={setMultipleDeleteDialog}
      none
      addnone
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
    >
      <CustomTable>
        {filterCustomerType.length > 0 && (
          <CustomTableHeading
            heading={[
              <Checkbox
                indeterminate={selected.length > 0 && selected.length < filterCustomerType.length}
                checked={filterCustomerType.length > 0 && selected.length === filterCustomerType.length}
                onClick={(event) => handleSelectAllClick(event, filterCustomerType, setSelected)}
              />,
              'name',
              'Customer Type code',
              'created date',
              'info',
            ]}
          />
        )}
        <TableBody>
          {!loading &&
            filterCustomerType.length > 0 &&
            paginatedData(filterCustomerType, page).map((item, index) => {
              const isItemSelected = isSelected(item, selected)
              return (
                <CustomTableRow>
                  <TableCell onClick={() => handleSelectedItem(item, selected, setSelected)}>
                    <Checkbox checked={isItemSelected} />
                  </TableCell>

                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.customerTypeCode}</TableCell>
                  <TableCell>{formatDate(item.createdAt)}</TableCell>
                  <TableCell>
                    <AiOutlineInfoCircle
                      style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                      // onClick={}
                      onClick={() => history.push(`/view-customerType/${item._id}`)}
                    />
                  </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      <ConfirmDialog
        open={deleteDialog}
        handleClose={() => setDeleteDialog(false)}
        name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteCustomerType({ customerTypeId: selected[0]._id }, setSelected)}
      />
      <ConfirmDialog
        open={multipleDeleteDialog}
        handleClose={() => setMultipleDeleteDialog(false)}
        // name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteManyCustomerType({ customerTypeId: multipleId }, setSelected)}
      />
      {loading && <Loader />}
      {!loading && filterCustomerType.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}
      {!loading && !filterCustomerType.length && <NoDataFound />}
    </Layout>
  )
}

export default CustomerTypes
